"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const native_1 = require("@react-navigation/native");
const react_native_1 = require("react-native");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const styles_1 = __importDefault(require("../../styles/styles"));
const constants_1 = require("../../constants/constants");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const callSlice_1 = require("./callSlice");
const voipCallOutbound_1 = __importDefault(require("../../components/communicationBox/voipCall/voipCallOutbound"));
const callLog_1 = __importDefault(require("../../components/callLog/callLog"));
const Call = () => {
    const dispatch = useAppDispatch_1.default();
    const { officer } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
    }));
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(callSlice_1.resetCallState());
        dispatch(callSlice_1.getCallLogs({}));
    }, []));
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS === constants_1.WEB_TAG ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Dashboard" }))),
            react_1.default.createElement(voipCallOutbound_1.default, { officer: officer }),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
                react_1.default.createElement(callLog_1.default, null)))));
};
exports.default = Call;
